
/**
 * 메시지 역할
 */
export type ConversationMessageRequestRole = typeof ConversationMessageRequestRole[keyof typeof ConversationMessageRequestRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationMessageRequestRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
